import PropTypes from 'prop-types';

export const DisplayableContent = {
  contentId: PropTypes.number.isRequired,
  contentThreadId: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
};

export const InsightWithConnectedAnalyses = {
  ...DisplayableContent,
  connectedAnalyses: PropTypes.arrayOf(PropTypes.shape(DisplayableContent))
    .isRequired,
};
